import template from './acris-blog-group-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-blog-group-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            showDeleteModal: false,
            repository: null,
            total: 0
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        entityRepository() {
            return this.repositoryFactory.create('acris_blog_group');
        },

        columns() {
            return this.getColumns();
        }
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort('createdAt', 'DESC'));

            this.entityRepository.search(criteria, Shopware.Context.api).then((items) => {
                this.total = items.total;
                this.items = items;
                this.isLoading = false;

                return items;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        // onDelete(id) {
        //     this.showDeleteModal = id;
        // },
        //
        // onCloseDeleteModal() {
        //     this.showDeleteModal = false;
        // },

        getColumns() {
            return [{
                property: 'internalName',
                inlineEdit: 'string',
                label: 'acris-blog-group.list.columnInternalName',
                routerLink: 'acris.blog.group.detail',
                allowResize: true,
                primary: true,
                width: '200px'
            }, {
                property: 'active',
                label: 'acris-blog-group.list.columnActive',
                inlineEdit: 'bool',
                allowResize: true,
                align: 'center',
                width: '80px'
            }];
        }
    }
});

